export default __webpack_public_path__ + "2020 C6 coefficients for interacting Rydberg atoms and alkali-metal dimers.pdf";